// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../tools/HBuilderX/plugins/uniapp-cli/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".position-top > .uni-popup__wrapper.bottom[data-v-4e764f8c]{top:10vh}", ""]);
// Exports
module.exports = exports;
